import '../../../utilities/stringUtils.js';
import { styled, useTheme } from '@vebox/etui-system';
import '../../../utilities/responsive.js';
import '../../../utilities/format-ms.js';
import '../../../utilities/create-transition.js';
import { useContext, createElement } from 'react';
import '../../../utilities/get-styleprop.js';
import { convertFormatToDateFns } from '../../../utilities/convertFormatToDateFns.js';
import '../../../useDebounce/useDebounce.js';
import '../../../useWindowSize/useWindowSize.js';
import '../../../useResponsive/useResponsive.js';
import { a as _objectSpread2 } from '../../../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../../../Svg-0180d7b5.js';
import '../../../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../../../Icon/icons.js';
import '../../../Icon/helper.js';
import '@vebox/etui-colors';
import '../../../ErrorLabel/ErrorLabel.js';
import '../../../FormItem/FormItem.js';
import '../../../Input/Input.js';
import '../../../InputLabel/InputLabel.js';
import '../../../TextInput/TextInput.js';
import '../../../InputAddon/InputAddon.js';
import 'react-dom';
import '../../../ClickOutside/ClickOutside.js';
import '../../../Tooltip/Tooltip.js';
import Button from '../../../Button/Button.js';
import '../../../Container/Row.js';
import '../../../Container/config.js';
import '../../../Container/Col.js';
import 'react-day-picker';
import '../../../DatePicker/DatePicker.js';
import '../../../DatePicker/NavBar.js';
import { format } from 'date-fns';
import '../../../DatePicker/formatters.js';
import '../../../H4/H4.js';
import 'react-modal';
import '../../../Modal-5d30452a.js';
import '../../../Modal/ModalHeader.js';
import '../../../Modal/Modal.js';
import DateRangePicker from '../../../DateRangePicker/DateRangePicker.js';
import 'react-popper';
import '../../../DropdownMenu/DropdownMenu.js';
import '../../../DropdownMenu/Item.js';
import '../../../DropdownMenu/Divider.js';
import 'lodash.isnil';
import { removeField } from '../../utils.js';
import '../../state/constants.js';
import { setValue, removeValue } from '../../state/actions.js';
import FilterPanelContext from '../../FilterPanelContext.js';
import ApplyFilterButton from '../ApplyFilterButton.js';
import '../../../TimePicker/constants.js';
import { i as isTimeValid } from '../../../utils-1a2b02cb.js';
import '../../../TimePicker/Field.js';
import TimePicker from '../../../TimePicker/TimePicker.js';
import '../../../TimePicker/TimePickerPanel.js';
import '../../../TimePicker/TimeField.js';
import '../../../TimePicker/TimePeriodFormatField.js';
import { C as ControlRow } from '../../../styles-14c01051.js';

const DateTimeControlWrapper = styled(Div)`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const DateTimeInputsContainer = styled(Div)`
  display: flex;
  width: ${({
  isClearable
}) => isClearable ? '90%' : '100%'};
`;

const DateTimeRangeControl = ({
  label,
  field,
  dateFormat: rawDateFormat = 'dd/MM/yy',
  timeFormat = 'HH:mm:ss',
  allowFutureDates = false,
  showApplyButton = false,
  applyButtonLabel
}) => {
  var _timeFormat$toLowerCa;
  const dateFormat = convertFormatToDateFns(rawDateFormat);
  const {
    state,
    dispatch
  } = useContext(FilterPanelContext);
  const savedDateRange = state.toBeAppliedFilters[field];
  const startDate = savedDateRange === null || savedDateRange === void 0 ? void 0 : savedDateRange.startDate;
  const endDate = savedDateRange === null || savedDateRange === void 0 ? void 0 : savedDateRange.endDate;
  const theme = useTheme();
  const dateRangePickerStyles = {
    root: {
      mr: `${theme.spacing.sm}px`,
      width: '90%'
    }
  };
  const useMeridiemTimeFormat = timeFormat === null || timeFormat === void 0 ? void 0 : (_timeFormat$toLowerCa = timeFormat.toLowerCase()) === null || _timeFormat$toLowerCa === void 0 ? void 0 : _timeFormat$toLowerCa.includes('a');
  const handleStartTimeChange = time => {
    if (time && isTimeValid(time)) {
      const newStartDate = new Date(startDate.getTime());
      newStartDate.setHours(parseInt(time.split(':')[0], 10));
      newStartDate.setMinutes(parseInt(time.split(':')[1], 10));
      dispatch(setValue(field, _objectSpread2(_objectSpread2({}, savedDateRange), {}, {
        startDate: newStartDate
      })));
    }
  };
  const handleEndTimeChange = time => {
    if (time && isTimeValid(time)) {
      const newEndDate = new Date(endDate.getTime());
      newEndDate.setHours(parseInt(time.split(':')[0], 10));
      newEndDate.setMinutes(parseInt(time.split(':')[1], 10));
      dispatch(setValue(field, _objectSpread2(_objectSpread2({}, savedDateRange), {}, {
        endDate: newEndDate
      })));
    }
  };
  const handleStartDateChange = ({
    startDate: dateValue
  }) => {
    if (dateValue) {
      dispatch(setValue(field, _objectSpread2(_objectSpread2({}, savedDateRange), {}, {
        startDate: dateValue
      })));
      return;
    }
    if (!endDate) {
      dispatch(removeValue(field));
      return;
    }
    dispatch(setValue(field, removeField(savedDateRange, 'startDate')));
  };
  const handleEndDateChange = ({
    startDate: dateValue
  }) => {
    if (dateValue) {
      dispatch(setValue(field, _objectSpread2(_objectSpread2({}, savedDateRange), {}, {
        endDate: dateValue
      })));
      return;
    }
    if (!endDate) {
      dispatch(removeValue(field));
      return;
    }
    dispatch(setValue(field, removeField(savedDateRange, 'endDate')));
  };
  const clearStartDateTime = () => {
    dispatch(setValue(field, removeField(savedDateRange, 'startDate')));
  };
  const clearEndDateTime = () => {
    dispatch(setValue(field, removeField(savedDateRange, 'endDate')));
  };
  return /*#__PURE__*/createElement(ControlRow, {
    id: field
  }, /*#__PURE__*/createElement(DateTimeControlWrapper, {
    mb: `${theme.spacing.md}px`,
    flex: 1
  }, /*#__PURE__*/createElement(DateTimeInputsContainer, {
    isClearable: !!startDate
  }, /*#__PURE__*/createElement(DateRangePicker, {
    dateFormat: dateFormat,
    name: `datetime-start-date-${field}`,
    startDate: startDate,
    endDate: startDate,
    disableRange: true,
    label: label.startDate,
    onChange: handleStartDateChange,
    styles: dateRangePickerStyles,
    size: "small",
    allowFutureDates: allowFutureDates
  }), /*#__PURE__*/createElement(TimePicker, {
    disabled: !startDate,
    name: `datetime-start-time-${field}`,
    value: startDate ? format(startDate, 'HH:mm:ss') : undefined,
    onChange: handleStartTimeChange,
    useMeridiem: useMeridiemTimeFormat,
    size: "small",
    isInlineEditMode: false
  })), !!startDate && /*#__PURE__*/createElement(Button, {
    iconProps: {
      glyph: icons.CLOSE
    },
    onClick: clearStartDateTime,
    styles: {
      root: {
        p: 0,
        width: '10%'
      }
    }
  })), /*#__PURE__*/createElement(DateTimeControlWrapper, null, /*#__PURE__*/createElement(DateTimeInputsContainer, {
    isClearable: !!endDate
  }, /*#__PURE__*/createElement(DateRangePicker, {
    dateFormat: dateFormat,
    name: `datetime-end-date-${field}`,
    startDate: endDate,
    endDate: endDate,
    disableRange: true,
    label: label.endDate,
    onChange: handleEndDateChange,
    styles: dateRangePickerStyles,
    size: "small",
    allowFutureDates: allowFutureDates
  }), /*#__PURE__*/createElement(TimePicker, {
    disabled: !endDate,
    name: `datetime-end-time-${field}`,
    value: endDate ? format(endDate, 'HH:mm:ss') : undefined,
    onChange: handleEndTimeChange,
    useMeridiem: useMeridiemTimeFormat,
    size: "small",
    isInlineEditMode: false
  })), !!endDate && /*#__PURE__*/createElement(Button, {
    iconProps: {
      glyph: icons.CLOSE
    },
    onClick: clearEndDateTime,
    styles: {
      root: {
        p: 0,
        width: '10%'
      }
    }
  })), showApplyButton && /*#__PURE__*/createElement(ApplyFilterButton, {
    field: field,
    applyButtonLabel: applyButtonLabel
  }));
};

export default DateTimeRangeControl;
